export default __webpack_public_path__ + "static/media/accountMenuPreferences.cd65f700.png";